import { useCallback, useMemo, useState } from "react";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const useFiiDii = () => {
  const [fiiDiiData, setFiiDiiData] = useState([]);
  const [fiiDiiLoading, setFiiDiiLoading] = useState(false);
  const [fiiDiiError, setFiiDiiError] = useState(null);

  const fetchFiiDiiData = useCallback(async (limit = 30) => {
    try {
      setFiiDiiLoading(true);
      setFiiDiiError(null);

      const response = await axios.get(`${BASE_URL}/api/fii-dii/data`, {
        params: {
          limit,
        },
      });

      const rows = Array.isArray(response?.data?.data)
        ? response.data.data
        : [];

      setFiiDiiData(rows);

      return rows;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch FII/DII data";

      console.error("Fetch FII/DII data failed:", error);

      setFiiDiiError(message);
      setFiiDiiData([]);

      return [];
    } finally {
      setFiiDiiLoading(false);
    }
  }, []);

  const fiiDiiByDate = useMemo(() => {
    const grouped = fiiDiiData.reduce((acc, row) => {
      const tradeDate = row?.trade_date;
      const category = row?.category;

      if (!tradeDate || !category) {
        return acc;
      }

      if (!acc[tradeDate]) {
        acc[tradeDate] = {
          trade_date: tradeDate,
          fii: null,
          dii: null,
        };
      }

      if (category === "FII/FPI") {
        acc[tradeDate].fii = row;
      }

      if (category === "DII") {
        acc[tradeDate].dii = row;
      }

      return acc;
    }, {});

    return Object.values(grouped).sort(
      (a, b) => new Date(b.trade_date) - new Date(a.trade_date),
    );
  }, [fiiDiiData]);

  const latestFiiDii = fiiDiiByDate?.[0] || null;

  const resetFiiDiiData = useCallback(() => {
    setFiiDiiData([]);
    setFiiDiiError(null);
  }, []);

  return {
    fiiDiiData,
    fiiDiiByDate,
    latestFiiDii,

    fiiDiiLoading,
    fiiDiiError,

    fetchFiiDiiData,
    resetFiiDiiData,
  };
};
